module.exports = __webpack_public_path__ + "4f9b0ba01e3e161a9e720057432eb3f3.pdf";